import { createContext, useContext, useEffect, useReducer, useState } from "react";
import authenticationReducer from "../../services/reducers/authenticationReducer";

export const AuthenticationContext = createContext({
  state: { ...authenticationReducer.initialState },
  dispatch: () => {},
});

export const useAuthenticationContext = () => useContext(AuthenticationContext);
function AuthenticationSlicer({ children }) {
  
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [redirectPath, setRedirectPath] = useState("/"); // Store the intended path

  const login = () => setIsAuthenticated(true);
  const logout = () => setIsAuthenticated(false);
  
  const [state, dispatch] = useReducer(
    authenticationReducer.reducer,
    authenticationReducer.initialState,
    (initial) => {
      const storedUserData = localStorage.getItem("userData");
      return storedUserData
        ? { ...initial, userData: JSON.parse(storedUserData) }
        : initial;
    }
  );

  return (
    <AuthenticationContext.Provider value={{ isAuthenticated, login, logout, redirectPath, setRedirectPath,  state, dispatch }}>
      {children}
    </AuthenticationContext.Provider>
  );
}

export default AuthenticationSlicer;
